// Import 'normalize.css' node module
import 'normalize.css';
// import 'angular';
import 'angular-sanitize';
import 'angular-animate';
import 'angular-cookies';
import 'angular-ui-bootstrap';


// Bootstrap  CSS
// import 'bootstrap/dist/css/bootstrap.min.css';

// Angular UI Bootstrap
// import 'angular-ui-bootstrap';

// Font-Awesome
// import '../vendor/font-awesome-4.5.0/css/font-awesome.min.css';
// import 'font-awesome/css/font-awesome.min.css';

// Kendo-ui
// import 'http://kendo.cdn.telerik.com/2016.2.504/js/jquery.min.js';
// import 'http://kendo.cdn.telerik.com/2016.2.504/js/kendo.all.min.js';
// import 'http://kendo.cdn.telerik.com/2016.2.504/styles/kendo.common.min.css';
// import 'http://kendo.cdn.telerik.com/2016.2.504/styles/kendo.default.min.css';

export default {};



/** WEBPACK FOOTER **
 ** ./src/app/external.js
 **/